import { IconButton, TextField } from '@mui/material'
import { DatePicker } from '@labrav/react-components'
import React, { useMemo } from 'react'
import HighlightOffIcon from '@mui/icons-material/HighlightOffOutlined'
import { useStyles } from './PricingComponent.styles'
import { Installments } from '../../../modules/privateOffer/types'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { isEmpty } from 'lodash'
import clsx from 'clsx'
import { getRandom, preventEventForKeys } from '@labrav/common'
import { createPaymentDateField, getInstallmentAmountValue } from './utils'

export type InstallmentsRowsProps = {
  index: number
  installmentsLength: number
  installment: Installments
  updateInstallments: (data: KeyValue) => void
  deleteRow: () => void
  flexiblePaymentTerms: boolean
  errors: Record<string, unknown>
}

export const InstallmentsRows = React.memo(
  ({
    index,
    installmentsLength,
    installment,
    updateInstallments,
    errors,
    deleteRow,
  }: InstallmentsRowsProps) => {
    const randomKey = useMemo(getRandom, [index, installmentsLength])
    const handleInputChange =
      (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        updateInstallments({
          key,
          value: getInstallmentAmountValue(event.target.value),
        })
      }
    const handleDateChanges = (date: string | null) => {
      updateInstallments({ key: 'paymentDate', value: date || '' })
    }

    const { classes } = useStyles()
    const field = createPaymentDateField(installment.paymentDate)
    return (
      <div
        className={classes.updateRow}
        data-testid="installment-row"
        key={`${randomKey}-${index}`}
      >
        <TextField
          id="amount"
          label="Amount"
          variant="standard"
          key={'amount'}
          type="number"
          error={!isEmpty((errors.amount as string).trim())}
          helperText={errors.amount as string}
          required={true}
          defaultValue={installment.amount}
          className={classes.textField}
          onChange={handleInputChange('amount')}
          onKeyDown={preventEventForKeys(['+', '-', 'e'])}
          slotProps={{
            input: { inputProps: { 'data-testid': 'amount', min: 0 } },
          }}
        />
        <div style={{ width: '211px' }}>
          <DatePicker
            field={field}
            handleDateChange={handleDateChanges}
            errorHelperText={errors.paymentDate as string}
            customClasses={clsx(classes.textField, classes.dateField)}
          />
        </div>
        <IconButton
          className={classes.closeIconButton}
          onClick={deleteRow}
          data-testid="cancel-button"
          size="large"
        >
          <HighlightOffIcon className={classes.closeIcon} />
        </IconButton>
      </div>
    )
  }
)
